
import { ChevronRight, ChevronLeft } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";

interface Conversation {
  id: string;
  name: string;
  avatar: string;
  status: "online" | "offline";
  lastMessage: string;
  time: string;
  unread: number;
  userId: string;
}

interface ChatHeaderProps {
  conversation: Conversation | undefined;
  showSidebar: boolean;
  onToggleSidebar: () => void;
  onStartVoiceCall: () => void;
  onStartVideoCall: () => void;
}

const ChatHeader = ({
  conversation,
  showSidebar,
  onToggleSidebar
}: ChatHeaderProps) => {
  const getInitials = (name: string) => {
    if (!name) return "?";
    return name
      .split(' ')
      .filter(word => word.length > 0)
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };

  return (
    <div className="p-4 border-b flex items-center justify-between">
      <div className="flex items-center">
        {!showSidebar && (
          <Button 
            variant="ghost" 
            size="sm" 
            className="mr-2 md:hidden" 
            onClick={onToggleSidebar}
          >
            <ChevronRight size={20} />
          </Button>
        )}

        {showSidebar && (
          <Button 
            variant="ghost" 
            size="sm" 
            className="mr-2 md:hidden" 
            onClick={onToggleSidebar}
          >
            <ChevronLeft size={20} />
          </Button>
        )}

        <Avatar className="h-10 w-10">
          <AvatarImage src={conversation?.avatar} alt={conversation?.name} />
          <AvatarFallback>{conversation?.name ? getInitials(conversation.name) : "?"}</AvatarFallback>
        </Avatar>
        <div className="ml-3">
          <h3 className="font-medium">{conversation?.name}</h3>
          <p className="text-xs text-gray-500 flex items-center">
            <span 
              className={`h-2 w-2 rounded-full mr-1 ${
                conversation?.status === "online" ? "bg-green-500" : "bg-gray-300"
              }`}
            ></span>
            {conversation?.status === "online" ? "Online" : "Offline"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
